import { Area } from "../enum/area.enum";
import { Role } from "../enum/roles.enum";

export const roleCheck = ({ roles, currentRole }: { roles: any[]; currentRole: Role | string | undefined }) =>
  roles.indexOf(currentRole) !== -1;
